import { Component, ElementRef, HostBinding, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Data, Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, filter, map, takeUntil } from 'rxjs/operators';

import { CalsoftMediaWatcherService } from 'src/app/global/services/media-watcher';
import { CalsoftNavigationService } from 'src/app/global/components/navigation';
import { UntypedFormControl } from '@angular/forms';
import { CrmSearchComponent } from 'src/app/shared/crm-search/crm-search.component';
import { MatDialog } from '@angular/material/dialog';
import { cloneDeep } from 'lodash-es';

@Component({
    selector: 'thin-layout',
    templateUrl: './thin.component.html',
    styleUrls: ['./thin.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ThinLayoutComponent implements OnInit, OnDestroy {

    sanitizedUrl: string = '';
    private _matAutocomplete: any;
    searchType: string = 'menu';

    @Input() debounce: number = 300;

    @Input() minLength: number = 2;

    url = '';

    data: any;
    isScreenSmall: boolean;
    path: any;

    appearance: string;

    @HostBinding('class.fixed-header')
    fixedHeader: boolean;

    @HostBinding('class.fixed-footer')
    fixedFooter: boolean;


    private _unsubscribeAll: Subject<any>;
    @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

    /**
     * Constructor
     *
     * @param {ActivatedRoute} _activatedRoute
     * @param {CalsoftMediaWatcherService} _calsoftMediaWatcherService
     * @param {CalsoftNavigationService} _calsoftNavigationService
     * @param {Router} _router
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _calsoftMediaWatcherService: CalsoftMediaWatcherService,
        private _calsoftNavigationService: CalsoftNavigationService,
        private _router: Router,
        private dialog: MatDialog,
    ) {
        this._unsubscribeAll = new Subject();

        this.fixedHeader = true;
        this.fixedFooter = false;
        this.url = this._router.url || '';
        this._router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this._router.url || ''; });

        this.url = this._router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
        this._router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => {
                this.url = this._router.url || '';
                this.sanitizedUrl = this.sanitizeUrl(this.url);
            });
    }


    get currentYear(): number {
        return new Date().getFullYear();
    }

    ngOnInit(): void {
        this._activatedRoute.data.subscribe((data: Data) => {
            this.data = data.initialData;
        });

        this._calsoftMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                this.isScreenSmall = matchingAliases.includes('lt-md');
            });


        this.searchControl.valueChanges
            .pipe(
                debounceTime(this.debounce),
                takeUntil(this._unsubscribeAll),
                map((value) => {

                    if (!value || value.length < this.minLength) {
                        this.resultSets = null;
                    }

                    return value;
                }),


                filter(value => value && value['length'] >= this.minLength)
            )
            .subscribe((value) => {

                this.resultSets = []
                if (value === '') {
                    return this.resultSets = [];
                }

                if (!this.data?.navigation?.compact?.[0]?.[0]?.search) {
                    return this.resultSets = [];
                }

                const flatNavigation = JSON.parse(this.data.navigation.compact[0][0].search);
                const clean = (s: string) => s ? s.toLowerCase().replace(/[\s\/\-_]+/g, '') : '';
                const valLower = value.toLowerCase();
                const valClean = clean(value);

                const pagesResults = cloneDeep(flatNavigation)
                    .filter(page => {
                        if (!page.link) return false;

                        const titleMatch = page.title && (page.title.toLowerCase().includes(valLower) || clean(page.title).includes(valClean));
                        const defaultNameMatch = page.defaultName && (page.defaultName.toLowerCase().includes(valLower) || clean(page.defaultName).includes(valClean));
                        const linkMatch = page.link && (page.link.toLowerCase().includes(valLower) || clean(page.link).includes(valClean));
                        const nameMatch = page.name && (page.name.toLowerCase().includes(valLower) || clean(page.name).includes(valClean));

                        return titleMatch || defaultNameMatch || linkMatch || nameMatch;
                    });

                if (pagesResults.length > 0) {
                    this.resultSets.push({
                        id: 'pages',
                        label: 'Pages',
                        results: pagesResults
                    });


                } else {
                    this.resultSets = []
                }

            });

    }


    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    /**
     * Toggle navigation
     *
     * @param key
     */
    toggleNavigation(key): void {
        // Get the navigation
        const navigation = this._calsoftNavigationService.getComponent(key);

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    onKeydown(event: KeyboardEvent): void {
        // Escape
        if (event.code === 'Escape') {
            // If the appearance is 'bar' and the mat-autocomplete is not open, close the search
            if (this.appearance === 'bar' && !this._matAutocomplete.isOpen) {
                this.close();
            }
        }
    }

    // search 

    opened: boolean = false;
    searchControl: UntypedFormControl = new UntypedFormControl();
    resultSets: any = []
    resultSets1: any[] = [{
        "id": "pages",
        "label": "Pages",
        "results": [{
            "id": "apps.contacts",
            "title": "Contacts",
            "type": "basic",
            "icon": "heroicons_outline:user-group",
            "link": "/apps/contacts",
            "value": "Contacts"
        },
        {
            "id": "user-interface.confirmation-dialog",
            "title": "Confirmation Dialog",
            "type": "basic",
            "icon": "heroicons_outline:question-mark-circle",
            "link": "/ui/confirmation-dialog",
            "value": "Confirmation Dialog"
        }
        ]
    }];

    open(): void {
        if (this.opened) {
            return;
        }

        setTimeout(() => {
            this.searchInput.nativeElement.focus();
        });
        this.opened = true;
    }

    close(): void {
        if (!this.opened) {
            return;
        }

        this.searchControl.setValue('');

        this.opened = false;
    }

    sanitizeUrl(u: string): string {
        return (u || '')
            .replace(/^\/+/, '')
            .replace(/[?#&=]/g, '-')
            .replace(/[^a-zA-Z0-9_-]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '')
            .toLowerCase();
    }

    protected _onDestroy = new Subject<void>();

    goToPopUp() {
        if (window.innerWidth > 768) {
            const dialogRef = this.dialog.open(CrmSearchComponent, {
                width: '80%',
                maxWidth: '1200px',
                height: '100%',
                data: {

                },
                position: { right: '0' },
                panelClass: 'slide-dialog-panel',
                hasBackdrop: true,
                disableClose: false
            });
        } else {
            const dialogRef = this.dialog.open(CrmSearchComponent, {
                minWidth: '100vw', height: '100vh',
                data: {

                },
                position: { right: '0' },
                panelClass: 'slide-dialog-panel',
                hasBackdrop: true,
                disableClose: false
            });
        }
    }

    onSearchTypeChange() {
        if (this.searchType === 'crm') {
            this.goToPopUp();
            // Reset to menu so the selection is ready for next time
            setTimeout(() => {
                this.searchType = 'menu';
            }, 100);
        } else if (this.searchType === 'menu') {
            this.open();
        }
    }

    getToRoute(link: any) {
        if (!link) return;
        this.close();
        const targetUrl = link.startsWith('/') ? link : '/' + link;
        this._router.navigateByUrl(targetUrl);
    }
}
